import Translate from "@casino/legacy/client/shared/i18n/Translate";
import NextLink from "@casino/legacy/client/shared/NextLink";
import Button from "@casino/legacyUi/Button";

type Props = {
  handle: string;
};

const ThemeLink: FC<Props> = ({ handle }) => {
  if (!handle) {
    return null;
  }
  return (
    <div className="mb-2 mr-2 inline-block">
      <NextLink href={`/themes/${handle}`}>
        <Button size="xs" variant="outline" className="bg-transparent">
          <span className="text-2xs-caption font-medium uppercase text-foreground">
            #<Translate id={`casino.theme.${handle}`} />
          </span>
        </Button>
      </NextLink>
    </div>
  );
};

export default ThemeLink;
